import { AxiosResponse } from 'axios';
import { ErrorConverter } from '../errorHandling/ErrorConverter';

/**
 * Axios success response interceptor.
 * Detects 200 + Fault responses and converts them to CapturedApiFaultErrors.
 */
export function axiosSuccessResponseInterceptor<ResponseType>(
  response: AxiosResponse<ResponseType>,
  returnFullResponse?: boolean
) {
  if (ErrorConverter.isSuccessResponseWithFault(response)) {
    const apiFaultError = ErrorConverter.fromFaultResponse(response);

    return Promise.reject(apiFaultError);
  }

  if (returnFullResponse) {
    return response;
  }

  return response.data;
}

/**
 * Axios rejected response interceptor.
 * Converts raw HTTP errors to CapturedApiErrors via ErrorConverter.
 */
export function axiosRejectedResponseInterceptor(error: any) {
  return Promise.reject(
    ErrorConverter.isRawHttpError(error)
      ? ErrorConverter.fromHttpError(error)
      : error
  );
}
